import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Collection;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { IconArrowOpenDownLine, IconArrowOpenUpLine } from '@instructure/ui-icons';
import { Transition } from '@instructure/ui-motion';
import { IconButton } from '@instructure/ui-buttons';
import { jsx } from '@instructure/emotion';
import PositionSummary from '../../PositionSummary';
import { DISPLAY_AS_SUMMARY_LIMIT } from '../presenter';
import t from '@instructure/quiz-i18n/es/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
export var Collection = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Collection = /*#__PURE__*/function (_Component) {
  function Collection() {
    var _this;
    _classCallCheck(this, Collection);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Collection, [].concat(args));
    _defineProperty(_this, "handleSidebarHideItems", function () {
      _this.props.setSidebarStimulusIsShowing(_this.props.stimulusId, false);
    });
    _defineProperty(_this, "handleSidebarShowItems", function () {
      _this.props.setSidebarStimulusIsShowing(_this.props.stimulusId, true);
    });
    return _this;
  }
  _inherits(Collection, _Component);
  return _createClass(Collection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.makeStyles();
    }
  }, {
    key: "shouldDisplayAllItems",
    value: function shouldDisplayAllItems() {
      return this.props.itemCollection.size <= DISPLAY_AS_SUMMARY_LIMIT;
    }
  }, {
    key: "renderItems",
    value:
    // =============
    //   RENDERING
    // =============

    function renderItems() {
      var _this2 = this;
      var _this$props = this.props,
        firstPosition = _this$props.firstPosition,
        isShowingItems = _this$props.isShowingItems,
        itemCollection = _this$props.itemCollection,
        sidebarOpen = _this$props.sidebarOpen;
      var nextDisplayPosition = firstPosition;
      var itemComponents = itemCollection.toArray().map(function (item, i) {
        var displayPosition = nextDisplayPosition;
        nextDisplayPosition += item.displayPositionSlots;
        return jsx("div", {
          key: item.id,
          css: _this2.props.styles.sidebarItemContainer
        }, _this2.props.renderSidebarItem(item, displayPosition, sidebarOpen));
      });
      var transitionType = isShowingItems ? 'slide-down' : 'slide-up';
      return jsx(Transition, {
        "in": isShowingItems || this.shouldDisplayAllItems(),
        type: transitionType
      }, jsx("div", null, jsx("div", {
        css: this.props.styles.sidebarItem,
        "data-testid": "sidebar-item"
      }, jsx(IconButton, {
        onClick: this.handleSidebarHideItems,
        withBackground: false,
        withBorder: false,
        renderIcon: IconArrowOpenUpLine,
        screenReaderLabel: t('Collapse stimulus questions')
      })), jsx("div", null, itemComponents)));
    }
  }, {
    key: "renderItemSummaryOnClosedSidebar",
    value: function renderItemSummaryOnClosedSidebar() {
      var _this$props2 = this.props,
        firstPosition = _this$props2.firstPosition,
        itemCollection = _this$props2.itemCollection,
        isShowingItems = _this$props2.isShowingItems;
      var transitionType = !isShowingItems ? 'slide-up' : 'slide-down';
      return jsx(Transition, {
        "in": !isShowingItems,
        type: transitionType
      }, jsx("div", {
        css: this.props.styles.column
      }, jsx(PositionSummary, {
        firstPosition: firstPosition,
        lastPosition: firstPosition + itemCollection.size - 1
      }), jsx(IconButton, {
        onClick: this.handleSidebarShowItems,
        withBackground: false,
        withBorder: false,
        renderIcon: IconArrowOpenDownLine,
        screenReaderLabel: t('Expand stimulus questions')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.container,
        "data-testid": "container"
      }, jsx("div", {
        css: this.props.styles.items,
        "data-testid": "items"
      }, this.renderItemSummaryOnClosedSidebar()), jsx("div", {
        css: this.props.styles.summary,
        "data-testid": "summary"
      }, this.renderItems()));
    }
  }]);
}(Component), _defineProperty(_Collection, "displayName", 'Collection'), _defineProperty(_Collection, "componentId", "Quizzes".concat(_Collection.displayName)), _defineProperty(_Collection, "propTypes", {
  // Passed in by Sidebar
  firstPosition: PropTypes.number.isRequired,
  isOver: PropTypes.bool.isRequired,
  /* This is used for when the stimulus is being dragged in build */
  renderSidebarItem: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  itemCollection: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  isShowingItems: PropTypes.bool,
  stimulusId: PropTypes.string.isRequired,
  // set in connect
  setSidebarStimulusIsShowing: PropTypes.func.isRequired,
  styles: PropTypes.object,
  makeStyles: PropTypes.func
}), _defineProperty(_Collection, "defaultProps", {
  isShowingItems: false
}), _Collection)) || _class);
export default Collection;